/**
 * CSRF Context Provider
 * Provides CSRF token to all components in the app
 */

import React, { createContext, useContext } from 'react';
import { useCsrfToken } from '../hooks/useCsrfToken';

const CsrfContext = createContext(null);

export const CsrfProvider = ({ children }) => {
  const csrfData = useCsrfToken();

  return (
    <CsrfContext.Provider value={csrfData}>
      {children}
    </CsrfContext.Provider>
  );
};

export const useCsrf = () => {
  const context = useContext(CsrfContext);
  if (!context) {
    throw new Error('useCsrf must be used within CsrfProvider');
  }
  return context;
};

